import { EventEmitter, EventMap, Handler } from "excalibur";

export const Canceled = "canceled" as const;
export type Canceled = typeof Canceled;

export interface IFlow<FlowCompleteData> {
  onComplete(
    callback: Handler<FlowCompleteEvent<FlowCompleteData | Canceled>>,
  ): IFlow<FlowCompleteData>;
  Execute(): void | Promise<void>;
  Suspended(): void;
  Restored(evt: FlowRestoredEvent): void;
  Cancel(): void;
  name(): string;
}

export class FlowCompleteEvent<Data> {
  constructor(
    public flow: IFlow<unknown>,
    public data: Data | Canceled,
  ) {}
}

export type FlowRestoredEvent = Event;

export type FlowEvents<CompleteData> = {
  complete: FlowCompleteEvent<CompleteData | Canceled>;
};

export const FlowEvents = {
  complete: "complete",
} as const;

type StrictEventKey<TEventMap> = keyof TEventMap;
export class StrictEventEmitter<
  TEventMap extends EventMap,
> extends EventEmitter<TEventMap> {
  emit<TEventName extends StrictEventKey<TEventMap>>(
    eventName: TEventName,
    event: TEventMap[TEventName],
  ): void;
  emit<TEventName extends StrictEventKey<TEventMap> | string>(
    eventName: TEventName,
    event?: TEventMap[TEventName],
  ): void {
    super.emit(eventName as string, event as unknown);
  }
}
